<template>
  <div>
    <div class="welcome" style="border: 0px solid red;">
      <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
        <div class="box box-primary">
          <div class="box-body">
            <div>
              <b-table
                :items="gridDataList"
                :fields="gridColumns"
                class="mt-3"
                outlined
                responsive
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #cell(description)="scope">
                  <div>{{ getDescription(scope.item) }}</div>
                </template>
              </b-table>
            </div>
          </div>
          <div
            v-if="gridDataList.length > 0"
            class="box-footer clearfix"
            style="display:contents;"
          >
            <paginator
              style="padding: 0 15px"
              :totalItem="paginateData.totalItem"
              :currentPage="paginateData.currentPage"
              :pageSize="paginateData.pageSize"
              :totalPage="paginateData.totalPage"
              @onpaginate="onPagination"
            />
          </div>
        </div>
      </row>
    </div>

    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Enum from "../../../enum/enum";
import utils from "@/lib/utils";
import Loading from "vue-loading-overlay";
import Paginator from "@/components/CustomPaginator.vue";

export default {
  components: {
    loading: Loading,
    paginator: Paginator
  },
  data: () => ({
    isLoading: false,
    gridColumns: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center "
      },
      {
        label: "invoice.invoice_number",
        key: "invoiceNumber",
        class: "text-center "
      },
      {
        label: "invoice.invoiceName",
        key: "invoiceName",
        class: "text-left "
      },
      {
        label: "invoice.apartment_code",
        key: "apartmentCode",
        class: "text-left "
      },
      {
        label: "invoice.invoiceHistory.userUpdated",
        key: "userCreated",
        class: "text-center "
      },
      {
        label: "project_history.date_created",
        key: "dateCreated",
        class: "text-center "
      },
      {
        label: "project_history.description",
        key: "description",
        class: "text-center "
      }
    ],
    gridDataList: [],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    searchData: {
      searchText: null,
      userCreatedName: null,
      dateFrom: null,
      dateTo: null
    }
  }),
  watch: {
    GET_INVOICE_HISTORY_DATA: function() {
      let paginate = this.GET_INVOICE_HISTORY_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_INVOICE_HISTORY_DATA.results;
      this.gridDataList = [];
      data.forEach((element, i) => {
        let id = element.id;
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          id: id,
          nonumber: nonumber,
          invoiceNumber: element.invoice_data.invoice_number,
          invoiceName: element.service_data.name,
          userCreated: element.user_created_data.full_name,
          dateCreated: utils.formatSqlDate(element.date_created, null, "HH:mm DD/MM/YYYY"),
          actionType: element.type,
          totalFees: element.total_fees,
          inDebtValue: element.in_debt_value,
          apartmentCode: element.apartment_data.apartment_code
        };
        this.gridDataList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_INVOICE_HISTORY_DATA"
    ])
  },
  methods: {
    onRefreshData: function(data) {
      this.searchData.searchText = data.searchText
      this.searchData.userCreatedName = data.userCreatedName
      this.searchData.dateFrom = data.dateFrom
      this.searchData.dateTo = data.dateTo
      this.getInvoiceHistory(1);
    },
    getInvoiceHistory: function(page) {
      let fromFormat = "DD/MM/YYYY"
      let toFormat = "YYYY-MM-DD HH:mm:ss"
      let data = {
        params: {
          page: page,
          searchText: utils.getCleanStringValue(this.searchData.searchText),
          userCreatedName: utils.getCleanStringValue(this.searchData.userCreatedName),
          dateFrom: utils.formatSqlUtcDate(this.searchData.dateFrom, fromFormat, toFormat),
          dateTo: utils.formatSqlUtcEndOfDate(this.searchData.dateTo, "DD/MM/YYYY HH:mm:ss", toFormat)
        }
      };
      this.isLoading = true;
      this.GET_INVOICE_HISTORY(data)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function(error) {
            this.isLoading = false;
            this.ON_SHOW_TOAST({
              message: error.response.data.message,
              styleType: "danger"
            });
          }.bind(this)
        );
    },
    onPagination: function(page) {
      this.getInvoiceHistory(page);
    },
    getDescription: function(data) {
      let result = "";
      let actionType = data.actionType;
      let actionTypeText = "";
      switch (actionType) {
        case Enum.ActionHistoryEnum.CREATE:
          actionTypeText = this.$t('invoice.invoiceHistory.actionName.CREATE');
          break;

        case Enum.ActionHistoryEnum.UPDATE:
          actionTypeText = this.$t('invoice.invoiceHistory.actionName.UPDATE');
          break;

        case Enum.ActionHistoryEnum.DELETE:
          actionTypeText = this.$t('invoice.invoiceHistory.actionName.DELETE');
          break;

        case Enum.ActionHistoryEnum.SEND_EMAIL:
          actionTypeText = this.$t('invoice.invoiceHistory.actionName.SEND_EMAIL');
          break;

        case Enum.ActionHistoryEnum.SEND_NOTIFICATION:
          actionTypeText = this.$t('invoice.invoiceHistory.actionName.SEND_NOTIFICATION');
          break;

        default:
          break;
      }
      result = `${actionTypeText} ${data.invoiceName}`;
      let totalFees = utils.getCleanStringValue(data.totalFees);
      if (totalFees) {
        result += `, ${this.$t('invoice.invoiceHistory.totalFees')} ${totalFees}`;
      }
      let inDebtValue = utils.getCleanStringValue(data.inDebtValue);
      if (inDebtValue) {
        result += `, ${this.$t('invoice.invoiceHistory.inDebtValue')} ${inDebtValue}`;
      }
      return result;
    },
    ...mapActions([
      "ON_SHOW_TOAST",
      "GET_INVOICE_HISTORY"
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Invoice/InvoiceHistory.vue